<template>
  <div>
    <v-card color="#EFF4F8" class="py-1 pl-2 placeholder-card" outlined>
      <header class="d-flex">
        <p class="float-left mr-4 mb-0 body-2 grey--text text--darken-3">
          Insert Tag
        </p>
        <v-menu offset-y class="cursor-pointer float-left">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="
                black--text
                float-left
                secondary--font
                body-1
                font-weight-medium-custom
              "
            >
              <span class="secondary--font"> Ticket </span>
              <v-icon v-if="attrs['aria-expanded'] == 'false'">
                mdi-menu-down
              </v-icon>
              <v-icon v-if="attrs['aria-expanded'] == 'true'">
                mdi-menu-up
              </v-icon>
            </span>
          </template>

          <v-list>
            <v-list-item-group>
              <v-list-item
                class="cursor-pointer"
                v-for="(item, index) in ticketTagList"
                :key="index"
                @click="addPlaceHolder(item)"
              >
                <v-list-item-title class="text-lowercase">
                  {{ item.name | upperCaseFirst }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
        <v-menu offset-y class="cursor-pointer float-left ml-2">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="
                black--text
                float-left
                font-weight-medium-custom
                body-1
                ml-2
              "
            >
              <span class="secondary--font"> Contact </span>
              <v-icon v-if="attrs['aria-expanded'] == 'false'">
                mdi-menu-down
              </v-icon>
              <v-icon v-if="attrs['aria-expanded'] == 'true'">
                mdi-menu-up
              </v-icon>
            </span>
          </template>
          <v-list>
            <v-list-item-group>
              <v-list-item
                class="cursor-pointer"
                v-for="(item, index) in contactTagList"
                :key="index"
                @click="addPlaceHolder(item)"
              >
                <v-list-item-title class="text-lowercase">
                  {{ item.name | upperCaseFirst }}</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </header>
    </v-card>
  </div>
</template>

<script>
import { $replytemplates } from "@/services/Index";

export default {
  name: "Place-holders",
  data: () => {
    return {
      ticketTagList: [],
      contactTagList: [],
    };
  },
  mounted() {
    this.getTicketTags();
    this.getContactTags();
  },
  methods: {
    /** method on select of liquid tag */
    addPlaceHolder(item) {
      this.$emit("onSelect", item.value);
    },

    /** get list of ticket liquid tags */
    async getTicketTags() {
      let payload = {};
      try {
        const response = await $replytemplates.ticketTags(payload, {});
        if (response.data) {
          this.ticketTagList = response.data;
        }
      } catch (error) {
        if (error.response !== undefined) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Error",
              message: this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(error.response.data).subjectText()} `,
              }),
              type: "error",
            },
          ]);
        }
      }
    },

    /** get list of contact liquid tags */

    async getContactTags() {
      let payload = {};
      try {
        const response = await $replytemplates.contactTags(payload, {});
        if (response.data) {
          this.contactTagList = response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.placeholder-card {
  border: 1px solid #ccc !important;
  border-top: 0px !important;
}
</style>
